import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
 * Gibt alle Friedhöfe zurück.
 */
export function getLabel(id: number): JQueryPromise<modelsGet.ILabel>
{
    var endpoint = new URI("api/labels");
    endpoint.segment(id.toString());

    return api.get<modelsGet.ILabel>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Friedhöfe zurück.
 */
export function getLabels(): JQueryPromise<modelsGet.ILabel[]>
{
    var endpoint = new URI("api/labels");

    return api.get<modelsGet.ILabel[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(label: modelsPost.ILabel): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/labels/create",
        data: JSON.stringify(label)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, label: modelsPost.ILabel): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/labels/edit/${id}`,
        data: JSON.stringify(label)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/labels/delete/${id}`
    });
}